/* eslint-disable no-shadow */
import { Action } from '@reduxjs/toolkit';
import { combineEpics, StateObservable } from 'redux-observable';
import { Observable, from, of } from 'rxjs';
import {
  map, switchMap, first, filter, catchError, tap, ignoreElements,
} from 'rxjs/operators';

import { EVENTS } from '../../../constants/postMessage';
import { logDevelopmentError } from '../../../util/logDevelopmentError';
import { postMessage } from '../../../util/postMessage';
import { menuActions } from '../../actions';
import { cashierWidgetSelector, isEvoWrappedSelector } from '../../selectors';
import { RootState } from '../../types';
import { openCashier } from './utils';

const { cashier } = menuActions;

const cashierEpic = (action$: Observable<Action>, state$: StateObservable<RootState>) => action$.pipe(
  filter(cashier.request.match),
  filter(() => !isEvoWrappedSelector(state$.value)),
  switchMap(() => state$.pipe(
    first(),
    filter((state) => Boolean(cashierWidgetSelector(state))),
  )),
  switchMap(({ config: { authParams, cashier }, user }) => from(
    openCashier({
      cashier,
      user,
      authParams,
    })
  ).pipe(
    map((ok) => ({ ok })),
    catchError((e) => of({ ok: false, message: e.message }))
  )),
  map(({ ok, message }: any) => (
    ok ? cashier.success() : cashier.failure({ message }))),
);

const cashierEpicOss = (action$: Observable<Action>, state$: StateObservable<RootState>) => action$.pipe(
  filter(cashier.request.match),
  filter(() => Boolean(isEvoWrappedSelector(state$.value))),
  tap(() => {
    try {
      postMessage({
        event: EVENTS.REQUEST_CASHIER,
      }, false);
    } catch (error: any) {
      logDevelopmentError(error.message);
    }
  }),
  ignoreElements()
);

export default combineEpics(cashierEpic, cashierEpicOss);
